import {
    AnyAction,
    applyMiddleware,
    combineReducers,
    compose,
    createStore,
    Middleware,
    Store,
    StoreEnhancerStoreCreator,
} from 'redux';
import DataFlow from './dataFlow';
import type { IReducer, IReducers, IState, Saga0 } from './interface';
import reducerCreator from './reducerCreator';
import sagaMiddleWare, { runSaga } from './sagaMiddleWare';

class StoreCreator {
    public static get store() {
        if (!StoreCreator._store) {
            throw new Error('你确定你createStore了吗？');
        }
        return StoreCreator._store;
    }

    public static create(
        data: IState,
        flow: { appReducer?: IReducer; rootSaga?: Saga0 },
        options?: { isNeedCombine: boolean },
    ) {
        options = Object.assign({ isNeedCombine: true }, options);
        const reducers: IReducers = {};
        const { appReducer = StoreCreator.getDefaultReducer() } = flow;
        const { rootSaga } = flow;
        const appReducerWrapper = reducerCreator(appReducer);

        let finalReducer: IReducer;
        if (options.isNeedCombine) {
            Object.keys(data).forEach((key: string) => {
                const reducerWrapper = reducerCreator(StoreCreator.getDefaultReducer());
                reducers[key] = reducerWrapper;
                DataFlow.addReducers(key, reducerWrapper);
            });
            finalReducer = (state: IState | undefined, action: AnyAction) => {
                return appReducerWrapper(combineReducers(reducers)(state, action), action);
            };
        } else {
            finalReducer = appReducerWrapper;
        }

        DataFlow.addReducers('app', appReducerWrapper);
        const store = StoreCreator._create(data, finalReducer, [sagaMiddleWare]);
        if (rootSaga) {
            runSaga(rootSaga);
        }
        StoreCreator._store = store;
        return store as any /** FIXME: */;
    }

    private static _store: Store;

    private static getDefaultReducer() {
        return (state: IState | undefined, _action: AnyAction) => state || {};
    }

    private static _create(data: IState, reducer: IReducer, middlewares: Middleware[] = []): Store {
        return compose(applyMiddleware(...middlewares))(createStore as StoreEnhancerStoreCreator<{}, {}>)(
            // @ts-ignore
            reducer,
            data,
        );
    }
}

export default StoreCreator;
